import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { API_BASE_URL } from '@gisgo/shared';

const TOKEN_KEY = 'gisgo-ops-token';

/** Bearer Sanctum sur les appels API. TODO(auth) : storage dédié + 401 → logout. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = inject(API_BASE_URL);
  const token = localStorage.getItem(TOKEN_KEY);

  if (token && req.url.startsWith(apiBaseUrl)) {
    return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
  }
  return next(req);
};
